import React, { useCallback, useEffect, useState } from "react";
import { SimpleViewModal } from "../../components/Modals/SimpleViewModal";
import { Input } from "../../components/Input";
import { useMaskito } from "@maskito/react";
import { maskitoNumberOptionsGenerator } from "@maskito/kit";
import { useTranslation } from "../../hooks/useTranslation";
import { useRightsApi } from "../../api/useRightsApi";

type Props = {
  payload: { share: number; territory_shares: number[] } | null
  onClose: (share: number | null) => void;
}
export const ModalChangeShare: React.FC<Props> = ({ payload, onClose }) => {
  const { t } = useTranslation();
  const { postShareUpdate } = useRightsApi();
  const [isLoading, setIsLoading] = useState(false);
  const [shareValue, setShareValue] = useState<null | number>(payload?.share ?? null);

  useEffect(() => {
    setShareValue(payload?.share ?? null);
  }, [payload]);

  const rightPercentInputRef = useMaskito({
    options: maskitoNumberOptionsGenerator({
      max: 100,
      min: 0,
      precision: 0,
      decimalSeparator: "."
    })
  });

  const handleSuccess = useCallback(async () => {
    try {
      setIsLoading(true);
      await postShareUpdate({ share: shareValue as number, territory_shares: payload?.territory_shares ?? [] });
      onClose(shareValue);
    } finally {
      setIsLoading(false);
    }
  }, [shareValue, payload?.territory_shares]);

  if (payload == null) {
    return null;
  }

  return <SimpleViewModal
    title={"Редактировать долю"}
    className={"py-[10px] w-1/3"}
    isSuccessLoading={isLoading}
    disableSuccess={isLoading}
    onSuccess={handleSuccess}
    onCancel={() => onClose(null)}
  >
    <div className={"my-[10px]"}>
      <Input
        required
        ref={rightPercentInputRef}
        onWheel={(e) => (e.target as any).blur()}
        className={"mt-1"}
        label={`${t("copyright_share")}`}
        value={shareValue ?? undefined}
        onInput={(e) => {
          const value = e.currentTarget.value;
          if (value === "") {
            setShareValue(null);
            return;
          }

          setShareValue(value as any);
        }}
        onChange={(value) => undefined}
      />
    </div>
  </SimpleViewModal>;
};
